import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/cc";
import { Film, AlertTriangle } from "lucide-react";

const pretty = (s) => (s || "").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

// kind: entity | source | claim  -> /entertainment/for-{kind}/{id}
export function EntReciprocal({ kind, id }) {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    if (!id) return;
    api.get(`/entertainment/for-${kind}/${id}`).then((r) => setRows(r.data)).catch(() => {});
  }, [kind, id]);
  return (
    <Card className="p-4" data-testid={`ent-reciprocal-${kind}`}>
      <div className="label-caps text-zinc-500 text-[0.6rem] mb-3 flex items-center gap-2"><Film className="h-3.5 w-3.5 text-fuchsia-400" /> Linked Entertainment Intelligence</div>
      {rows.length === 0 && <p className="text-xs text-zinc-600" data-testid={`ent-reciprocal-empty-${kind}`}>No linked entertainment records.</p>}
      <div className="space-y-1.5">
        {rows.map((r) => (
          <a key={r.id} href={`/command-center/entertainment/${r.id}`} data-testid={`ent-recip-${r.id}`} className="block text-xs border-b border-zinc-900 pb-1.5 hover:bg-zinc-900/40 rounded-sm px-1">
            <div className="flex items-center gap-1.5">
              {r.is_serious && <AlertTriangle className="h-3 w-3 text-red-400" title="Sensitive allegation" />}
              <span className="text-zinc-200 font-medium">{r.title}</span>
            </div>
            <div className="text-zinc-500 mt-0.5 flex flex-wrap gap-x-2">
              <span>{pretty(r.sector)}</span><span>· {pretty(r.record_type)}</span>
              <span>· {pretty(r.development_state)}</span><span>· {pretty(r.verification)}</span>
              {(r.release_date_revised || r.event_date) && <span>· {r.release_date_revised || r.event_date}</span>}
              <span>· {r.country}{r.city ? ` / ${r.city}` : ""}</span>
              <span>· {pretty(r.relationship)}</span>
            </div>
          </a>
        ))}
      </div>
    </Card>
  );
}
